<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();
const rgiTypes = computed(() => props.catalog.rgi_types || []);
const isCashPayment = computed(
  () =>
    Boolean(props.catalog.property?.cash_payment) ||
    (props.catalog.property?.payment_methods || [])
      .map(value => String(value))
      .includes('1')
);
const update = (field, value) =>
  emit('update:value', { ...props.value, [field]: value });
</script>

<template>
  <section class="grid gap-4">
    <div>
      <h2 class="text-lg font-semibold text-lais-text">
        {{ t('POST_SALE.FORM.REGISTRY.TITLE') }}
      </h2>
      <p class="mt-1 text-sm text-lais-text-body">
        {{ t('POST_SALE.FORM.REGISTRY.DESCRIPTION') }}
      </p>
    </div>
    <label
      v-if="isCashPayment"
      class="flex items-center gap-2 text-sm font-semibold text-lais-text-body"
    >
      <input
        :checked="Boolean(value.check_registro)"
        type="checkbox"
        @change="update('check_registro', $event.target.checked)"
      />
      <span>{{ t('POST_SALE.FORM.REGISTRY.COMPANY') }}</span>
    </label>
    <div class="grid gap-4 sm:grid-cols-2">
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.FORM.REGISTRY.TYPE') }}
        <select
          :value="value.tipo_rgi"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
          @change="update('tipo_rgi', $event.target.value)"
        >
          <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
          <option v-for="type in rgiTypes" :key="type.id" :value="type.id">
            {{ type.name }}
          </option>
        </select>
      </label>
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.FORM.REGISTRY.PROTOCOL') }}
        <input
          :value="value.protocolo_rgi"
          :placeholder="t('POST_SALE.FORM.REGISTRY.PROTOCOL_PLACEHOLDER')"
          class="min-h-10 rounded-lais border border-lais-border px-2 font-normal"
          @input="update('protocolo_rgi', $event.target.value)"
        />
      </label>
    </div>
  </section>
</template>
